import Price from './price';
import PriceMiniature from './PriceMiniature';
export { PriceMiniature };
export default Price;